import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aa7b0238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "location-bg" }
const _hoisted_2 = { class: "location-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "location-header-mobile" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Trailer Solutions")
], -1))
const _hoisted_4 = { class: "location-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "location-title" }, " You'll be asked to turn on location sharing ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "location-explanation" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "location-app-open-text" }, [
    /*#__PURE__*/_createTextVNode(" • Your location is "),
    /*#__PURE__*/_createElementVNode("strong", null, "ONLY"),
    /*#__PURE__*/_createTextVNode(" shared when the app is open, and "),
    /*#__PURE__*/_createElementVNode("strong", null, "NEVER"),
    /*#__PURE__*/_createTextVNode(" outside of Knight-Swift. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "location-sharing-text" }, [
    /*#__PURE__*/_createTextVNode(" • While location sharing is "),
    /*#__PURE__*/_createElementVNode("strong", null, "OPTIONAL"),
    /*#__PURE__*/_createTextVNode(", it provides more accurate trailer data. ")
  ])
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "location-close" }
const _hoisted_9 = { class: "actions-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FbxButton = _resolveComponent("FbxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          class: "location-content",
          style: _normalizeStyle(_ctx.contentStyle)
        }, _hoisted_7, 4),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_FbxButton, {
              "button-text": "Continue",
              theme: "primary",
              class: "portrait-text-color",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('continue')))
            })
          ])
        ])
      ])
    ])
  ]))
}